import React from 'react'

const SwingBy = () => {
  return (
    <div
    className="w3-half w3-dark-grey w3-container w3-center"
    style={{ height: 700 }}
  >
    <div className="w3-padding-64">
      <h1>Swing By</h1>
    </div>
    <div className="w3-padding-64">
      <p>..for a cup of coffee, or whatever.</p>
      <p>Chicago, US</p>
      <p>+00 1515151515</p>
      <p>test@test.com</p>
    </div>
  </div>
  )
}

export default SwingBy